import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../services/api';
import WorkerLayout from '../../layouts/WorkerLayout';
import Button from '../../components/common/Button';

export default function WorkerPayment() {
  const { type } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading]   = useState(false);
  const [order, setOrder]       = useState(null);
  const [success, setSuccess]   = useState(false);

  const paymentType = type === 'renew' ? 'renewal' : 'registration';

  async function initiatePayment() {
    setLoading(true);
    try {
      const res = await api.post('/payments/initiate', { payment_type: paymentType });
      setOrder(res.data.data);
      openRazorpay(res.data.data);
    } catch {}
    finally { setLoading(false); }
  }

  function openRazorpay(orderData) {
    const options = {
      key:         process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_xxx',
      amount:      orderData.amount * 100,
      currency:    'INR',
      name:        'naukarihaat.com',
      description: paymentType === 'registration' ? 'Worker Registration Fee' : 'Registration Renewal Fee',
      order_id:    orderData.orderId,
      handler:     async (response) => {
        try {
          await api.post('/payments/verify', {
            razorpay_order_id:   response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature:  response.razorpay_signature,
          });
          setSuccess(true);
          toast.success('Payment successful! Your profile is now active.');
        } catch {
          toast.error('Payment verification failed. Please contact support.');
        }
      },
      prefill: { contact: '' },
      theme: { color: '#e1670e' },
      modal: { ondismiss: () => setLoading(false) },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  }

  if (success) {
    return (
      <WorkerLayout>
        <div className="max-w-sm mx-auto text-center py-16">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl">✅</span>
          </div>
          <h2 className="text-xl font-bold text-gray-900">Payment Successful!</h2>
          <p className="text-gray-500 mt-2">Your registration is now active for 1 year.</p>
          <Button fullWidth className="mt-6" onClick={() => navigate('/worker/dashboard')}>Go to Dashboard</Button>
        </div>
      </WorkerLayout>
    );
  }

  return (
    <WorkerLayout>
      <div className="max-w-sm mx-auto py-8">
        <h1 className="text-xl font-bold text-gray-900 mb-6">
          {paymentType === 'registration' ? 'Registration Payment' : 'Renewal Payment'}
        </h1>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 space-y-4">
          <div className="text-center">
            <span className="text-4xl">💳</span>
            <h2 className="text-3xl font-bold text-gray-900 mt-3">₹10</h2>
            <p className="text-gray-500 text-sm mt-1">
              {paymentType === 'registration' ? 'One-time registration fee' : 'Annual renewal fee'}
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-4 space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Fee Amount</span>
              <span className="font-medium">₹10.00</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">GST</span>
              <span className="font-medium">Included</span>
            </div>
            <div className="flex justify-between border-t pt-2">
              <span className="font-semibold text-gray-900">Total</span>
              <span className="font-bold text-gray-900">₹10.00</span>
            </div>
          </div>

          <div className="text-xs text-gray-500 space-y-1">
            <p>✓ Valid for 1 year from payment date</p>
            <p>✓ UPI / Debit Card / Net Banking accepted</p>
            <p>✓ Secure payment via Razorpay</p>
          </div>

          <Button fullWidth loading={loading} onClick={initiatePayment}>
            Pay ₹10 Now
          </Button>
          <p className="text-xs text-center text-gray-400">
            Can't pay online? Ask our team to mark offline payment.
          </p>
        </div>
      </div>
    </WorkerLayout>
  );
}
